import { render, staticRenderFns } from "./QualityStandardDialog.vue?vue&type=template&id=9c992180&scoped=true&"
import script from "./QualityStandardDialog.vue?vue&type=script&lang=js&"
export * from "./QualityStandardDialog.vue?vue&type=script&lang=js&"
import style0 from "./QualityStandardDialog.vue?vue&type=style&index=0&id=9c992180&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c992180",
  null
  
)

export default component.exports